import { combineReducers } from 'redux';
import authReducer from './authReducer';
import { baseApi } from '../../endpoints/createApi';

const rootReducer = combineReducers({
  auth: authReducer, // Assuming authReducer is imported
  [baseApi.reducerPath]: baseApi.reducer,
});

export default rootReducer;
